// This middleware is
// * To set the current language code before the page is load
export default function (context) {
	const locale = context.$cookie.get('locale')
	if (locale) {
		context.store.commit('settings/setLanguage', locale)
	}
}